import { useState } from 'react';
import { createPortal } from 'react-dom';
import { MessageSquarePlus } from 'lucide-react';
import FeedbackDialog from './FeedbackDialog';

const FeedbackFab = () => {
  const [open, setOpen] = useState(false);

  const fab = (
    <>
      <button
        onClick={() => setOpen(true)}
        aria-label="Submit Feedback"
        style={{
          position: 'fixed',
          bottom: '24px',
          right: '24px',
          zIndex: 99999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '48px',
          height: '48px',
          borderRadius: '9999px',
          border: 'none',
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          transition: 'transform 200ms',
        }}
        className="bg-primary text-primary-foreground hover:scale-105 active:scale-95 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 md:h-14 md:w-14 print:hidden"
      >
        <MessageSquarePlus className="h-5 w-5 md:h-6 md:w-6" />
      </button>
      <FeedbackDialog open={open} onOpenChange={setOpen} />
    </>
  );

  // Portal to document.body to avoid any container overflow/clipping issues
  return createPortal(fab, document.body);
};

export default FeedbackFab;
